import React, { Component } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import LocalizedStrings from "react-localization";
import { ModalHeader } from "reactstrap";
import * as firebase from "firebase";

//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    Changeby: "Changed By",
    Changeon: "Changed On",
    Password: "Password",
    permission: "Permission",
    showInfoButton: "Show Info",
    noDataTitle: "No data found",
    passwordInfoHeader: "Password Info",
    authHeader: "Authentication",
    passwordInputTitle: "Enter your account password",
    closeBtn: "Close",
    confirmBtn: "Confirm",
  },
  ja: {
    Changeby: "変更者",
    Changeon: "変更日",
    Password: "パスワード",
    permission: "権限",
    showInfoButton: "情報を表示",
    noDataTitle: "データが見つかりません",
    passwordInfoHeader: "パスワード情報",
    authHeader: "認証",
    passwordInputTitle: "アカウントのパスワードを入力してください",
    closeBtn: "閉じる",
    confirmBtn: "確認",
  },
  es: {
    Changeby: "Cambiado Por",
    Changeon: "Cambiado El",
    Password: "Contraseña",
    permission: "Permiso",
    showInfoButton: "Mostrar Info",
    noDataTitle: "No se encontraron datos",
    passwordInfoHeader: "Información de Contraseña",
    authHeader: "Autenticación",
    passwordInputTitle: "Ingrese la contraseña de su cuenta",
    closeBtn: "Cerrar",
    confirmBtn: "Confirmar",
  },
});

class TagInfoButton extends Component {
  constructor(props) {
    super(props);

    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    const lockserial = this.props.lockSerial;

    this.state = {
      lockserial: lockserial,
      noDataText: "loading...",
      showPopup: false,
      showPopup2: false,
      loading: false,
      adminName: "",
      authError: false,
    };
  }

  componentWillMount() {
    //! FOR LANGUAGE
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }
  handleEnterKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.passwordAccess(); // Trigger the passwordAccess function on Enter key press
    }
  };

  passwordAccess = () => {
    this.setState({
      showPopup: true,
    });
    const user = fire.auth().currentUser;
    const { password } = this.state;
    // console.log(user.email)
    // console.log(fire.auth(user.email, password))

    var credential = firebase.auth.EmailAuthProvider.credential(
      user.email,
      password
    );
    user
      .reauthenticateAndRetrieveDataWithCredential(credential)
      .then(() => {
        // console.log('User reauthenticated successfully');
        this.handlePopupOpen();
        this.setState({
          showPopup: false,
          authError: false,
          password: null,
        });
      })
      .catch((error) => {
        // console.error('Error reauthenticating:', error);
        this.setState({ authError: true });
      });
  };

  passwordAccessClose = () => {
    this.setState({ showPopup: false, authError: false, password: null });
  };

  handlePopupOpen() {
    this.setState({
      showPopup2: true,
    });
    let TagInformation = [];

    fire
      .database()
      .ref("passwordBackups")
      .child(this.state.lockserial)
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((snapshotChild) => {
          TagInformation.push(snapshotChild.val());
        });
      })
      .then(() => {
        if (TagInformation.length > 0) {
          const lastEntry = TagInformation[TagInformation.length - 1];

          const changedBy = lastEntry.changedBy || "Unknown";

          const formattedEntry = {
            changedBy,
            changedOn: lastEntry.changedOn,
            password: lastEntry.password,
          };

          // console.log(lastEntry.changedOn);
          let myDate = new Date();
          myDate = new Date(lastEntry.changedOn + myDate.getTimezoneOffset());
          // console.log(myDate);
          formattedEntry.changedOn = myDate.toString();
          // console.log(formattedEntry.changedOn);
          // console.log(formattedEntry);

          this.setState({
            TagInformation: formattedEntry,
          });
          customLog(formattedEntry);
        } else {
          this.setState({
            noDataText: localizationStrings.noDataTitle,
          });
        }
        customLog(TagInformation);
      });

    if (TagInformation.length <= 0) {
      this.setState({
        noDataText: localizationStrings.noDataTitle,
      });
    }
  }

  handlePopupClose() {
    this.setState({ showPopup2: false });
  }

  remarkFormat(remark) {
    if (remark !== null && remark !== undefined && remark !== "") {
      return remark;
    } else {
      return localizationStrings.none;
    }
  }

  // adminNameFormat(adminUid) {

  //   fire
  //     .database()
  //     .ref("registeredIndustrialUsersOnPlatform")
  //     .child(adminUid)
  //     .once("value")
  //     .then(async usersDetail => {
  //       await this.setState({
  //         adminName: usersDetail.val().name
  //       });
  //     })
  // }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }
    const { showPopup, password } = this.state;

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };

    const lastEntry = this.state.TagInformation;
    return (
      <div>
        <Modal show={this.state.showPopup2} onHide={this.handlePopupClose}>
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.passwordInfoHeader}</Modal.Title>
          </Modal.Header>
          {/* <Modal.Body>
          {lastEntry ? (
            <table className="table">
              <thead>
                <tr>
                    <th>{localizationStrings.Changeby}</th>
                    <th>{localizationStrings.Time}</th>
                    <th>{localizationStrings.Password}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {Object.values(lastEntry).map((value, index) => (
                    <td key={index}>{value}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          ) : (
            <p>{this.state.noDataText}</p>
          )}
        </Modal.Body> */}
          <Modal.Body>
            {lastEntry ? (
              <div>
                <div style={{ display: "flex", marginBottom: "10px" }}>
                  <span style={{ width: "110px" }}>
                    {localizationStrings.Changeby} :
                  </span>
                  <span>{lastEntry.changedBy}</span>
                </div>
                <div style={{ display: "flex", marginBottom: "10px" }}>
                  <span style={{ width: "110px" }}>
                    {localizationStrings.Changeon} :
                  </span>
                  <span>{lastEntry.changedOn}</span>
                </div>
                <div style={{ display: "flex", marginBottom: "10px" }}>
                  <span style={{ width: "110px" }}>
                    {localizationStrings.Password} :
                  </span>
                  <span>{lastEntry.password}</span>
                </div>
              </div>
            ) : (
              <p>{this.state.noDataText}</p>
            )}
          </Modal.Body>
        </Modal>
        <div>
          <Modal show={showPopup} onHide={this.passwordAccessClose}>
            <Modal.Header closeButton>
              <Modal.Title>{localizationStrings.authHeader}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="my-form">
                <div className="form-group">
                  <label htmlFor="formPassword">
                    {localizationStrings.Password}
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="formPassword"
                    placeholder={localizationStrings.passwordInputTitle}
                    value={password}
                    onChange={(e) =>
                      this.setState({ password: e.target.value })
                    }
                    onKeyDown={this.handleEnterKeyPress}
                  />
                </div>
              </form>
            </Modal.Body>
            <div style={{ margin: "auto", width: "96%" }}>
              <Button
                className="btn btn-info"
                style={{ borderRadius: "50px" }}
                onClick={this.passwordAccessClose}
              >
                {localizationStrings.closeBtn}
              </Button>
              <Button
                className="btn btn-info"
                style={{
                  borderRadius: "50px",
                  marginBottom: "15px",
                  marginTop: "10px",
                }}
                onClick={this.passwordAccess}
              >
                {localizationStrings.confirmBtn}
              </Button>
              {this.state.authError && (
                <p
                  style={{
                    color: "red",
                    textAlign: "center",
                    marginBottom: "15px",
                  }}
                >
                  Wrong Password
                </p>
              )}
            </div>
          </Modal>
        </div>

        <Button
          onClick={this.passwordAccess}
          className="btn btn-info"
          style={{ borderRadius: "50px" }}
        >
          {localizationStrings.showInfoButton}
        </Button>
      </div>
    );
  }
}

export default TagInfoButton;
